// extracted by mini-css-extract-plugin
export default {"consolidatedBudgetList":"consolidatedBudgetList_consolidatedBudgetList__U6oQC"};